import {
  Module,
  VuexModule,
  Mutation,
  Action,
} from 'vuex-module-decorators';

import {
  BASE_URL,
  SETTING_IMAGE,
  EDIT_IMAGE,
  EDIT_THEME,
  UPLOAD_IMAGE,
  THEME_SELECTION,
  UPDATE_THEME,
  GET_WHITE_LABEL,
  CORE_URL,
  M_POST,
} from '@/utils/api';

import Vue from 'vue';

@Module({ name: 'whitelabel' })
export default class WhiteLabel extends VuexModule {
  list: any = [];

  @Mutation
  mutateSettingImage(whitelabel) {
    this.list = whitelabel;
  }

  @Action({ commit: 'mutateSettingImage' })
  FetchSettingImage(params = {}) {
    return Vue.axios({
      url: BASE_URL + SETTING_IMAGE,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;

        if (code === 0) {
          const _data = data.data;
          delete _data.image.game.loadingBackgroundColor;
          delete _data.image.game.svgLoading;
          delete _data.image.game.licence;
          delete _data.image.landingPage;
          delete _data.image.game.landscapeLicence;
          return data.data;
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Action
  EditSettingTheme(params = {}) {
    return Vue.axios({
      url: BASE_URL + EDIT_THEME,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => data)
      .catch((err) => err);
  }

  @Action
  UploadImage(params) {
    return Vue.axios({
      url: BASE_URL + UPLOAD_IMAGE,
      data: params,
      method: M_POST,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then(({ data }) => data)
      .catch((err) => err);
  }

  @Action
  ImageUpdate(params) {
    return Vue.axios({
      url: BASE_URL + EDIT_IMAGE,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => data)
      .catch((err) => err);
  }

  @Action
  LandingPageSetting(params = {}) {
    return Vue.axios({
      url: BASE_URL + SETTING_IMAGE,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => data)
      .catch((err) => err);
  }

  @Action
  ThemeSelectionSetting(params = {}) {
    return Vue.axios({
      url: BASE_URL + THEME_SELECTION,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => data)
      .catch((err) => err);
  }

  @Action
  UpdateThemeSelectionSetting(params = {}) {
    return Vue.axios({
      url: BASE_URL + UPDATE_THEME,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => data)
      .catch((err) => err);
  }

  @Action
  FetchWhiteLabel(params = {}) {
    return Vue.axios({
      url: CORE_URL + GET_WHITE_LABEL,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => data.data)
      .catch((err) => err);
  }
}
